// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2Ikym","modalForm":"UpgradeEpcsModal_modalForm__1k4BS","modalFooter":"UpgradeEpcsModal_modalFooter__fsis6"};